/**
 * Utility function to ensure exhaustive checks in switch statements or discriminated unions.
 * Throws an error if called, indicating that a code path was not expected to be reached.
 *
 * @param val - The value that should never occur (enforced by TypeScript's `never` type).
 * @param message - A custom error message to provide context.
 * @throws {Error} Always throws, including the unexpected value in the error message.
 */
export const assertNever = (val: never, message: string): never => {
  throw new Error(`${message}: ${JSON.stringify(val)}`)
}
